import React, { createContext, useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { axiosPost } from "../utils/apis/api";

const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
  const [translations, setTranslations] = useState(
    localStorage.getItem("translations")
      ? JSON.parse(localStorage.getItem("translations"))
      : {}
  );

  const fetchTranslations = async (lang) => {
    try {
      const response = await fetch(
        `https://crm.alltimestravels.com/api/method/alltimes.www.api.get_translation_file?lang=${lang}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        console.error(`HTTP error! status: ${response.status}`);
        return;
      }

      const data = await response.json();
      setTranslations(data.message);
      localStorage.setItem("translations", JSON.stringify(data.message));
    } catch (error) {
      console.error(`Error fetching translations: ${error}`);
    }
  };


// const fetchTranslations = async (lang) => {
//   try {
//     const response = await axiosPost(
//       '/api/method/alltimes.www.api.get_translation_file',
//       { lang }, // sending lang in POST body
//       { "Content-Type": "application/json" }
//     );

//     if (response.status !== 200) {
//       console.error(`HTTP error! status: ${response.status}`);
//       return;
//     }

//     const data = response.data;
//     setTranslations(data.message);
//     localStorage.setItem("translations", JSON.stringify(data.message));
//   } catch (error) {
//     console.error(`Error fetching translations: ${error}`);
//   }
// };

  const t = (key) => {
    return translations[key] || key;
  };

  // Fetch translations on first mount
  useEffect(() => {
    const preferredLang = Cookies.get("preferred_language") || "en";
    fetchTranslations(preferredLang);
  }, []);

  return (
    <TranslationContext.Provider value={{ t, fetchTranslations }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => useContext(TranslationContext);
